import React from "react";
import "./About.css";
import { GiInkSwirl } from "react-icons/gi";
import aboutimage from "../../Images/Psynexa website photos cover 4.jpg";
import { FaEye } from "react-icons/fa6";
import { FaHouseMedicalFlag } from "react-icons/fa6";
import mission1 from "../../Images/visiionedit234.png";
import mission2 from "../../Images/mission21.png";
import Facilty from "../../commanfile/Facilty";
import { SiTicktick } from "react-icons/si";
import { FaBuilding } from "react-icons/fa";
import { HiMiniSquares2X2 } from "react-icons/hi2";
import { GiMedicines } from "react-icons/gi";
import { TbLineDotted } from "react-icons/tb";
import { RiStethoscopeFill } from "react-icons/ri";
import { MdAddCall } from "react-icons/md";
import pageslides from "../../Images/TWS00055.jpg";
import Pageslide from "../../commanfile/Pageslide";

const AboutHospital = () => {
  return (
    <>
      <div className="max-w-[1456px] mx-auto  ">
        <div className="mx-auto">
          <Pageslide name={""}
          imgaes={pageslides}
          className={"w-[100%] lg:h-[800px] pt-3  sm:w-[100%]"} />
        </div>

        <div className=" lg:flex  md:flex lg:items-center md:items-center  mt-10 justify-between   lg:px-20 md:px-16 px-8 ">
          <div className=" md:w-[50%]">
            <span className="font-roboto font-semibold items-center border-b-4 border-[#469B8F] py-2 gap-3 pt-2 md:text-4xl sm:text-2xl text-xl md:pt-10  text-[#469B8F] flex ">
              <GiInkSwirl className="md:text-4xl sm:text-2xl text-xl" />
              Psynexa Best Mind Care Center
            </span>

            <p className="  md:text-xl  sm:text-lg text-base font-roboto  mt-3  text-justify  ">
              Psynexa Mind Care Hospital is a revolutionary mental healthcare
              hospital in India with integrating cutting-edge clinical science
              and modern technological advancements. The organisation aims to
              create a mental health ecosystem where compassionate care meets
              expertise. Our innovative approach ensures personalized &
              effective care for every individual and their family.
            </p>
            <p className="md:text-xl  sm:text-lg text-base font-roboto mt-3 text-justify  ">
              Psynexa aims to create a mental health ecosystem that provides
              treatment and care plans for a range of mental health conditions
              like anxiety, depression, bipolar disorder, ADHD, OCD,
              schizophrenia and addictions.
            </p>
          </div>
          <div className=" ml-2 sm:w-[80%] md:w-[40%] pt-2 items-center ">
            <img
              src={aboutimage}
              className=" md:rounded-s-full rounded-xl  w-full"
            />
          </div>
        </div>
        <div className="mt-10 py-10 mx-auto bg-teal-50  ">
          <div className="md:flex justify-around px-10 items-center">
            <div className="">
              <img
                src={mission1}
                className="rounded-lg mx-auto "
                alt="image"
              />
            </div>
            <div className="md:w-[50%]">
              <p className=" text-2xl font-roboto font-bold border-b-4 border-black text-[#469B8F] flex items-center gap-2">
                <FaEye className=" text-2xl font-bold" />
                Our Vision
              </p>
              <p className="font-roboto md:text-lg sm:text-base text-sm text-justify p-2">
                At Mind Care Hospital, we strive to create a world where mental
                health is recognized and supported. Our aim is to be a trusted
                center of excellence, offering compassionate and expert care. By
                combining advanced treatments with a nurturing environment, we
                help individuals overcome emotional challenges. We are dedicated
                to breaking the stigma and making quality mental health care
                accessible to all.
              </p>
            </div>
          </div>
          <div className="md:flex  justify-around px-10 items-center ">
            <div className=" md:w-[50%]  w-full md:py-5">
              <p className=" p-2 text-2xl font-roboto text-[#469B8F] border-b-4 border-black font-bold flex items-center gap-2">
                <FaHouseMedicalFlag className=" text-2xl font-bold" />
                Our Mission
              </p>
              <p className="font-roboto  md:text-lg sm:text-base text-sm text-justify p-2">
                At Psynexa Mind Care Hospital, our mission is to provide
                comprehensive and individualized mental health services using
                proven, evidence-based approaches for a wide range of conditions
                including addiction, schizophrenia, bipolar disorder, OCD, ADHD,
                anxiety, and depression. We are committed to eliminating the
                stigma associated with mental illness, equipping individuals and
                their families with the knowledge and support they need, and
                embracing innovation to enhance care outcomes. Most importantly,
                we are devoted to fostering a safe, inclusive, and compassionate
                space where every individual is respected, understood, and
                guided toward lasting recovery.
              </p>
            </div>
            <div className="">
              <img
                src={mission2}
                className=""
                alt="image"
              />
            </div>
          </div>
        </div>

        <div className="pl-[40px] pr-[40px] py-10">
          <div className="mx-auto text-center p-2 ">
            <p className="font-roboto font-semibold text-2xl  text-center">
              Our Medical Department
            </p>
            <p className="font-roboto text-[#469B8F] font-bold text-xl">
              <TbLineDotted className="mx-auto text-4xl" />
            </p>
          </div>
          <div className="flex flex-wrap  justify-center ">
            <Facilty
              icon={<SiTicktick />}
              title={"VIP Suite"}
              content={"Our VIP Suite offers enhanced privacy and comfort, ensuring a premium experience while supporting mental health professionals in delivering consistent and efficient care."
              }
            />

            <Facilty
              icon={<FaBuilding />}
              title={"Standerd Room"}
              content={
                " A thoughtfully designed hospital room that ensures patient comfort, safety, and efficient healthcare delivery."}
            />

            <Facilty
              icon={<HiMiniSquares2X2 />}
              title={"Shared Room"}
              content={
                " A general ward designed to accommodate multiple patients while maintaining safety, comfort, and efficiency."}
            />

            <Facilty
              icon={<GiMedicines />}
              title={"Pharmacy"}
              content={
                "Our in-house pharmacy ensures timely preparation and dispensing of prescribed medications. Our expert pharmacists play a crucial role in patient care and treatment success."}
            />

            <Facilty
              icon={<MdAddCall />}
              title={"Emergency Psychiatric Services"}
              content={
                " We provide immediate care for individuals experiencing severe mental health crisis, including suicidal thoughts, acute psychosis, or extreme agitation."}
            />

            <Facilty
              icon={<RiStethoscopeFill />}
              title={"Diagnostic and Laboratory Services"}
              content={
                "Comprehensive diagnostic and laboratory facilities support accurate psychiatric assessments and effective treatment planning."}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default AboutHospital;
